import React from 'react';
import { getTranslate, getActiveLanguage, setActiveLanguage  } from 'react-localize-redux';
import { connect } from 'react-redux';
import * as cookieServices from 'services/cookies/cookieServices';

import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import AccountIcon from 'material-ui/svg-icons/action/account-circle';
import Drawer from 'material-ui/Drawer';
import styles from './styles/topMenuControlStyles';
import {List, ListItem} from 'material-ui/List';
import Subheader from 'material-ui/Subheader';
import Divider from 'material-ui/Divider';
import Avatar from 'material-ui/Avatar';
import usImg from 'Content/Assets/images/flags/us.png';
import itImg from 'Content/Assets/images/flags/it.png';
import deImg from 'Content/Assets/images/flags/de.png';
import esImg from 'Content/Assets/images/flags/es.png';
import nlImg from 'Content/Assets/images/flags/nl.png';
import {white } from 'material-ui/styles/colors';

/**
 * action per logout
 */
import { logOut } from 'actions/userActions';

class TopMenuControl extends React.Component {
    constructor(props){
        super(props);
        this.state = {open: false};
        this.handleToggle = this.handleToggle.bind(this);
        this.handleLogOut = this.handleLogOut.bind(this);
        this.handleOnLanguageClick = this.handleOnLanguageClick.bind(this);
    }

    handleLogOut(e){
        e.preventDefault()
        this.props.logOut();
    }

    handleOnLanguageClick(e, langCode){
        e.preventDefault()
        console.info(langCode);
        cookieServices.saveLanguageCode(langCode);
        this.props.setActiveLanguage(langCode);
    }

    handleToggle = () => this.setState({open: !this.state.open});

    render() {
        const {translate, language, applicationName, currentUser} = this.props;

        var langImg = itImg;
        var currentLang = "";

        if(language.code === 'en-US')
        {
            langImg = usImg;
            currentLang  = translate('Languages.en-US');
        }
        if(language.code === 'de-DE')
        {
            langImg = deImg;
            currentLang  = translate('Languages.de-DE');
        }
        if(language.code === 'es-ES')
        {
            langImg = esImg;
            currentLang  = translate('Languages.es-ES');
        }
        if(language.code === 'it-IT')
        {
            langImg = itImg;
            currentLang  = translate('Languages.it-IT');
        }
        if(language.code === 'nl-NL')
        {
            langImg = nlImg;
            currentLang  = translate('Languages.nl-NL');
        }

        console.info("lang")
        console.info(language);
        return (
            <div>

                <FlatButton
                    style={{color: white} }
                    label={currentUser ? currentUser.username : ""}
                    onClick={this.handleToggle}
                    icon={ <AccountIcon />}
                    />

                <Drawer open={this.state.open} openSecondary={true} >

                    <div style={styles.avatar.div} onClick={this.handleToggle}>
                        <span style={styles.avatar.span}>
                            {applicationName}
                        </span>
                    </div>

                    <div style={styles.root}>
                        <div style={{width: '100%'}} >
                            {
                                currentUser && currentUser.account?
                                <List>
                                    <Subheader>General info</Subheader>
                                    <ListItem primaryText={translate('GLOBAL.nameAndSurname')} secondaryText={currentUser.firstName + " " + currentUser.lastName} />
                                    <ListItem primaryText={translate('GLOBAL.account')} secondaryText={currentUser.account.title} />
                                    <ListItem primaryText={translate('GLOBAL.email')} secondaryText={currentUser.email} />
                                </List>: null
                            }
                            <List>
                                <Subheader>{translate('Languages.language')}</Subheader>
                                <ListItem
                                    primaryText={currentLang}
                                    leftIcon={<Avatar src={langImg} />}
                                    initiallyOpen={false}
                                    primaryTogglesNestedList={true}
                                    nestedItems={[
                                        <ListItem
                                        style={language.code !== "en-US" ? null : {display: 'none'}}
                                        key={1}
                                        onClick={(e) => this.handleOnLanguageClick(e, 'en-US')}
                                        primaryText={translate('Languages.en-US')}
                                        leftIcon={<Avatar src={usImg} />}
                                        />,
                                        <ListItem
                                        style={language.code !== "de-DE" ? null : {display: 'none'}}
                                        key={2}
                                        onClick={(e) => this.handleOnLanguageClick(e, 'de-DE')}
                                        primaryText={translate('Languages.de-DE')}
                                        leftIcon={<Avatar src={deImg} />}
                                        />,
                                        <ListItem
                                        style={language.code !== "it-IT" ? null : {display: 'none'}}
                                        key={3}
                                        onClick={(e) => this.handleOnLanguageClick(e, 'it-IT')}
                                        primaryText={translate('Languages.it-IT')}
                                        leftIcon={<Avatar src={itImg} />}
                                        />,
                                        <ListItem
                                        style={language.code !== "es-ES" ? null : {display: 'none'}}
                                        key={4}
                                        onClick={(e) => this.handleOnLanguageClick(e, 'es-ES')}
                                        primaryText={translate('Languages.es-ES')}
                                        leftIcon={<Avatar src={esImg} />}
                                        />,
                                        <ListItem
                                        style={language.code !== "nl-NL" ? null : {display: 'none'}}
                                        key={5}
                                        onClick={(e) => this.handleOnLanguageClick(e, 'nl-NL')}
                                        primaryText={translate('Languages.nl-NL')}
                                        leftIcon={<Avatar src={nlImg} />}
                                        />
                                    ]}
                                />
                            </List>

                        <Divider />
                        <FlatButton
                            label={translate('GLOBAL.close')}
                            fullWidth={true}
                            onClick={this.handleToggle}
                        />
                        <Divider />
                        <RaisedButton
                            onClick={this.handleLogOut}
                            secondary={true}
                            fullWidth={true}
                            label={translate('GLOBAL.logOut')}/>
                        </div>

                    </div>
                </Drawer>
            </div>
        );
    }
}

TopMenuControl.propTypes = {
    //x: PropTypes.object,
    //x: PropTypes.func,
    //x: PropTypes.bool,
    //x: PropTypes.array.isRequired,
    //x: PropTypes.object.isRequired
}

function mapStateToProps(state, ownProps){
    console.info(state);
    return {
        translate: getTranslate(state.locale),
        currentLanguage: getActiveLanguage(state.locale).code,
        language: getActiveLanguage(state.locale),
        applicationName: state.appData && state.appData.selectedApplication ? state.appData.selectedApplication.name : "",
        currentUser: state.user.currentUser
    }
}
export default connect(mapStateToProps, {logOut, setActiveLanguage})(TopMenuControl);


// WEBPACK FOOTER //
// ./src/containers/layout/TopMenuControl.js